import { Injectable, signal } from '@angular/core';
import { getLDConfig } from '@env';
import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
import { LDClient, LDFlagValue } from 'launchdarkly-js-client-sdk';

@Injectable({
  providedIn: 'root',
})
export class LaunchdarklyService {
  private ldClient!: LDClient;
  private flagsSignal = signal<Record<string, LDFlagValue>>({});
  private isOffline = signal(true);

  constructor() {
    this.init();
  }

  async init() {
    const config = getLDConfig();

    const context: LaunchDarkly.LDContext = {
      key: config.launchdarklyEnvKey,
      kind: 'user',
    };

    this.ldClient = LaunchDarkly.initialize(config.launchdarklyClientId, context);

    const connected = await new Promise<boolean>(resolve => this.ldClient.on('initialized', () => resolve(true)));

    if (!connected) {
      return;
    }

    this.isOffline.set(false);
    this.flagsSignal.set(this.ldClient.allFlags());

    this.ldClient.on('change', () => {
      this.flagsSignal.set(this.ldClient.allFlags());
    });
  }

  isFlagEnabled<T extends LDFlagValue>(flagKey: string, defaultValue: T): T {
    if (this.isOffline()) {
      return typeof defaultValue === 'boolean' ? (true as T) : defaultValue;
    }

    return (this.flagsSignal()[flagKey] as T) ?? defaultValue;
  }
}
